import { ReactComponent as FacebookIcon } from "../../assets/social-media/facebook.svg";
import { ReactComponent as InstagramIcon } from "../../assets/social-media/instagram.svg";
import { ReactComponent as LinkedInIcon } from "../../assets/social-media/linkedin.svg";
import { ReactComponent as PinterestIcon } from "../../assets/social-media/pinterest.svg";
import { ReactComponent as TwitterIcon } from "../../assets/social-media/twitter.svg";
import { ReactComponent as YoutubeIcon } from "../../assets/social-media/youtube.svg";

import { ReactComponent as HotelsHippo } from "../../assets/hippo-services-logo/svg/hotelsHippo.svg";
import { ReactComponent as HippoCorporate } from "../../assets/hippo-services-logo/svg/hippoCorporate.svg";
import { ReactComponent as WellnessCeylon } from "../../assets/hippo-services-logo/svg/wellnessCeylon.svg";

import siteConfig from "../../config/site.js";
const usefulSiteLinks = siteConfig.links.usefulLinks;

// prettier-ignore
const usefulLinks= [
  // { id: 1, title: 'Who we are', path: usefulSiteLinks.whoWeAre, newTab: false },
  // { id: 2, title: 'News', path: usefulSiteLinks.news, newTab: false },
  // { id: 3, title: 'Careers', path: usefulSiteLinks.careers, newTab: false },
  // { id: 5, title: 'Site Map', path: usefulSiteLinks.siteMap, newTab: false },
  // { id: 7, title: 'FAQ', path: usefulSiteLinks.faq, newTab: false },
  
  { id: 4, title: 'Blog', path: usefulSiteLinks.blog, newTab: true },
  { id: 6, title: 'Partner portal', path: usefulSiteLinks.partnerPortal, newTab: true },
  { id: 16, title: 'List your property', path: usefulSiteLinks.listYourProperty, newTab: true },
  { id: 11, title: 'Help and support', path: usefulSiteLinks.helpAndSupport, newTab: true },

  { id: 12, title: 'Terms and conditions', path: usefulSiteLinks.terms, newTab: true },
  { id: 10, title: 'Privacy policy', path: usefulSiteLinks.privacyPolicy, newTab: true },
  { id: 13, title: 'Cookie policy', path: usefulSiteLinks.cookiePolicy, newTab: true },
  
  { id: 15, title: 'Disclaimer', path: usefulSiteLinks.disclaimer, newTab: true },

  { id: 17, title: 'Acceptable use policy', path: usefulSiteLinks.usePolicy, newTab: true },
  { id: 18, title: 'DSAR form', path: usefulSiteLinks.DSARForm, newTab: true },

  // { id: 8, title: 'Do not sell my info', path: usefulSiteLinks.doNotSellMyInfo, newTab: false },
  // { id: 9, title: 'Booking terms', path: usefulSiteLinks.bookingTerms, newTab: false },
  // { id: 14, title: 'Manage Cookie', path: usefulSiteLinks.manageCookie, newTab: false },
];

const socialLinks = siteConfig.links.socialMedia;

// prettier-ignore
// prettier-ignore
const socialMediaLinks  = [
  { id: 1, title: 'Facebook', path: socialLinks.facebook, newTab: true, svg: FacebookIcon },
  { id: 2, title: 'Instagram', path: socialLinks.instagram, newTab: true, svg: InstagramIcon },
  { id: 3, title: 'LinkedIn', path: socialLinks.linkedin, newTab: true, svg: LinkedInIcon },
  { id: 4, title: 'Pinterest', path: socialLinks.pinterest, newTab: true, svg: PinterestIcon },
  { id: 5, title: 'Twitter', path: socialLinks.twitter, newTab: true, svg: TwitterIcon },
  { id: 6, title: 'Youtube', path: socialLinks.youtube, newTab: true, svg: YoutubeIcon }
];

const servicesLinks = siteConfig.links.services;

// prettier-ignore
const hippoServices = [
  { id: 1, title: "HotelsHippo.com", path:servicesLinks.hotelsHippo, newTab: false, svg :HotelsHippo  , iconWidth : 249  },
  { id: 2, title: "Hippo Coporate", path: servicesLinks.hippoCorporate, newTab: false, svg : HippoCorporate , iconWidth : 158 },
  { id: 3, title: "Wellness Ceylon", path:  servicesLinks.wellnessCeylon, newTab: true, svg : WellnessCeylon, iconWidth : 245 },
];

// HotelsHippo
// HippoCorporate
// WellnessCeylon

export { usefulLinks, socialMediaLinks, hippoServices };
